import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type {
  UpstreamCommLogDetail,
  UpstreamCommLogItem,
  UpstreamCommLogQuery,
  UpstreamCommTraceSetting,
} from '@/types/upstreamCommLog';

export const adminUpstreamCommApi = {
  getTraceSetting() {
    return request<UpstreamCommTraceSetting>({
      url: '/admin/upstream-comm/trace-setting',
      method: 'GET',
    });
  },

  updateTraceSetting(enabled: boolean) {
    return request<UpstreamCommTraceSetting>({
      url: '/admin/upstream-comm/trace-setting',
      method: 'PATCH',
      data: { enabled },
    });
  },

  listLogs(query?: UpstreamCommLogQuery) {
    return request<PaginatedResult<UpstreamCommLogItem>>({
      url: '/admin/upstream-comm/logs',
      method: 'GET',
      params: query,
    });
  },

  logDetail(id: string) {
    return request<UpstreamCommLogDetail>({
      url: `/admin/upstream-comm/logs/${id}`,
      method: 'GET',
    });
  },
};
